import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { newsletterSubscribe } from '../../services/api';
import { newsletterEvents, userEvents } from '../../utils/analytics';
import './EmailForm.css';

const EmailForm = ({ 
  placeholder = "you@example.com",
  buttonText = "Join Free",
  onSuccess,
  onError,
  className = "",
  settings = {}
}) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await newsletterSubscribe(email, settings);
      newsletterEvents.subscribe('landing_page');
      userEvents.formSubmit('newsletter_subscribe', true);
      
      // Navigate to confirmation page
      navigate('/confirmation', { state: { email } });
      
      if (onSuccess) {
        onSuccess(email);
      }
    } catch (error) {
      // Handle different error types
      let errorMessage = 'Failed to sign up. Please try again.';
      
      if (error.response?.data?.detail) {
        errorMessage = error.response.data.detail;
      } else if (error.response?.status === 400) {
        errorMessage = 'This email is already subscribed to our newsletter.';
      } else if (error.response?.status === 500) {
        errorMessage = 'Server error. Please try again later.';
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      userEvents.formSubmit('newsletter_subscribe', false);
      userEvents.error('newsletter_subscribe', errorMessage);
      
      if (onError) {
        onError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`email-form-container ${className}`}>
      <form onSubmit={handleSubmit} className="email-form">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={placeholder}
          required
          disabled={loading}
          className="email-input"
        />
        <button
          type="submit" 
          className="join-button"
          disabled={loading}
        >
          {loading ? 'Joining...' : buttonText}
        </button>
      </form>
      
      <div className="disclaimer">
        <Link to="/unsubscribe" className="page-link">Unsubscribe</Link> Anytime, You're in Control.
      </div>
    </div>
  );
};

export default EmailForm;
